import IComponent from "components/commons/IComponent";
import "./ElevationProfile.scoped.css";
import ReactECharts from "echarts-for-react";
import geometryTools from "utils/geometryTools";
import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel";
import IdentifyManager from "components/MapViews/IdentifyManager";

let echartRef = null,
  timeout = 0,
  chartOption = {
    graphic: [
      {
        type: "text",
        left: "center",
        top: "center",
        z: 100,
        style: {
          fill: "#FFF",
          text: "Get started by drawing a line on the scene with draw tool",
          font:
            "bold 36px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen','Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',san-serif",
        },
      },
    ],
    xAxis: {
      type: "value",
      name: "Distance (m)",
      nameLocation: "middle",
      nameGap: 30,
      axisLabel: {
        color: "#aaaaaa",
      },
      axisLine: {
        lineStyle: {
          color: "#aaaaaa",
        },
      },
      showGrid: false,
      splitLine: {
        show: false,
      },
      axisPointer: {
        show: true,
        type: "line",
        label: {
          color: `#fff`,
          backgroundColor: `#0079c1`,
          formatter: null,
        },
      },
    },
    yAxis: {
      type: "value",
      name: "Elevation (m)",
      nameLocation: "middle",
      nameGap: 32,
      axisLabel: {
        color: "#ffffff",
      },
      axisLine: {
        lineStyle: {
          color: "#ffffff",
        },
      },
      splitLine: {
        lineStyle: {
          color: "#0079c1",
        },
      },
    },
    color: ["#dcdc00"],
    dataset: {
      source: [],
    },
    series: [
      {
        //data: [],
        type: "line",
        smooth: true,
        symbol: "none",
        lineStyle: {
          width: 3,
        },
        dimensions: ["x", "y", "coords"],
      },
      {
        symbolSize: 20,
        data: [],
        type: "scatter",
      },
    ],
    visualMap: {
      show: false,
      dimension: 100, // means the 100th column
      seriesIndex: 100,
      min: -1, // lower bound
      max: -1, // higher bound
      inRange: {
        // Size of the symbol
        color: "black",
        symbol: "circle",
        symbolSize: 2,
      },
    },
  },
  min_point_count = 250,
  _profile_infos = null,
  _profile_layer = null,
  _vertex_layer = null,
  _marker_layer = null,
  _sketchView = null;

class ElevationProfile extends IComponent {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.initElevProfileModel(this.props.mapView);
    IdentifyManager.enableIdentify = false;
    // disable download button when first completed loading
    let btn = document.querySelector(".EPMenuBar").querySelector(".download");
    btn.style.backgroundColor = "lightgrey";
    btn.style.pointerEvents = "none";
    if (this.props.mapView.scale > 2000) {
      chartOption.visualMap.seriesIndex = 100;
    } else {
      chartOption.visualMap.seriesIndex = 0;
    }
    this.props.mapView.watch("scale", (newV, oldV) => {
      // console.log("new scale", newV, "old scale", oldV);
      if (newV && oldV && newV != oldV) {
        if (
          oldV > 2000 &&
          newV <= 2000 &&
          chartOption.visualMap.seriesIndex != 0
        ) {
          chartOption.visualMap.seriesIndex = 0;
          this.setState({});
        } else if (
          oldV <= 2000 &&
          newV > 2000 &&
          chartOption.visualMap.seriesIndex == 0
        ) {
          chartOption.visualMap.seriesIndex = 100;
          this.setState({});
        }
      }
    });
  }

  componentWillUnmount() {
    IdentifyManager.enableIdentify = true;
    this.deleteAction();
    _profile_layer && _profile_layer.destroy();
    _vertex_layer && _vertex_layer.destroy();
    _marker_layer && _marker_layer.destroy();
    _profile_infos = null;
    _profile_layer = null;
    _vertex_layer = null;
    _marker_layer = null;
    _sketchView = null;
    echartRef = null;
  }

  placeMarkerOnScene(params) {
    let _indicatorLabelGraphic = new geometryTools.Graphic({
      symbol: this._createElevationSymbol(params.seriesData[0].data.coords[2]),
    });
    _indicatorLabelGraphic.geometry = new geometryTools.Point({
      x: params.seriesData[0].data.coords[0],
      y: params.seriesData[0].data.coords[1],
      // z: params.seriesData[0].data.coords[2],
      spatialReference: new geometryTools.SpatialReference({
        wkid: 102140,
      }),
    });
    let tmpGraphicsLayer = this.props.mapView.map?.allLayers.find(
      (i) => i.title === "Elevation Profile Marker Layer"
    );
    tmpGraphicsLayer.graphics.removeAll();
    tmpGraphicsLayer.graphics.add(_indicatorLabelGraphic);
  }
  _createElevationSymbol2D(elevation) {
    return {
      type: "text",
      color: "white",
      haloColor: "#0079c1",
      haloSize: "3.5px",
      text: `${Math.round(elevation * 100) / 100} m`,
      xoffset: 3,
      yoffset: 3,
      font: {
        size: 11,
        family: "Avenir Next",
        weight: "bold",
      },
    };
  }
  _createElevationSymbol(elevation) {
    if (this.props.mapView.type === "2d")
      return this._createElevationSymbol2D(elevation);
    return {
      type: "point-3d",
      symbolLayers: [
        {
          type: "text",
          font: {
            family: "Avenir Next",
          },
          text: `${Math.round(elevation * 100) / 100} m`,
          halo: { color: "#0079c1", size: 3.5 },
          material: { color: "#fff" },
          size: 11,
        },
      ],
      verticalOffset: {
        screenLength: 60,
        maxWorldLength: 500,
        minWorldLength: 100,
      },
      callout: {
        type: "line",
        size: 1.5,
        color: "#0079c1",
        border: {
          color: "#fff",
        },
      },
    };
  }
  labelFormatterFunc(params) {
    console.log("params", params);
    if (params.seriesData?.[0].seriesType != "line") return;
    this.placeMarkerOnScene(params);
    return `Distance:${Math.round(params.value * 100) /
      100}m\nHeight:${Math.round(params.seriesData[0]["data"]["y"] * 100) /
      100}m\nCoordinate: (${Math.round(
      params.seriesData[0].data.coords[0]
    )}, ${Math.round(params.seriesData[0].data.coords[1])})`;
  }
  getOption() {
    let option = JSON.parse(JSON.stringify(chartOption));
    option.graphic[0].style.opacity =
      option.dataset.source.length === 0 ? 1 : 0;
    option.xAxis.axisPointer.label.formatter = this.labelFormatterFunc.bind(
      this
    );
    return option;
  }
  initElevProfileModel(sceneView) {
    let tmpMap = this.props.mapView.map;
    if (!_profile_layer) {
      _profile_layer = geometryTools.createGraphicsLayerByElev(
        "Sketch GraphicsLayer",
        tmpMap
      );
    }
    if (!_vertex_layer) {
      _vertex_layer = geometryTools.createGraphicsLayerByElev(
        "Sketch GraphicsLayer Vertex",
        tmpMap
      );
      _vertex_layer.minScale = 2000;
    }
    if (!_marker_layer) {
      _marker_layer = geometryTools.createGraphicsLayerByElev(
        "Elevation Profile Marker Layer",
        tmpMap,
        "relative-to-ground"
      );
    }
    if (!_sketchView) {
      let symbol =
        this.props.mapView.type === "2d"
          ? { type: "simple-line", width: 3.5, color: [220, 220, 0] }
          : {
              type: "line-3d",
              symbolLayers: [
                {
                  type: "line",
                  size: 3.5,
                  material: { color: [220, 220, 0] },
                },
              ],
            };
      _sketchView = new SketchViewModel({
        view: this.props.mapView,
        layer: _profile_layer,
        polylineSymbol: symbol,
      });
    }
    _sketchView.on("create", (event) => {
      // console.log(event.state, event.graphic);
      switch (event.state) {
        case "start":
          _profile_layer.removeAll();
          _vertex_layer.removeAll();
          break;
        case "active":
        case "complete":
          if (event.graphic) {
            clearTimeout(timeout);
            timeout = setTimeout(
              () => this.setPath(event.graphic.geometry),
              200
            );
          }
          break;
        default:
          break;
      }
    });
    _sketchView.on("update", (event) => {
      // console.log(event.graphic);
      _sketchView.update(event.graphic);
      if (event.state !== "cancel") {
        if (_sketchView.updateGraphics.length !== 0) {
          _sketchView.complete();
        } else {
          _sketchView.cancel();
        }
      }
    });
    _sketchView.on("delete", (event) => {
      this.setPath();
    });
  }
  drawAction(event) {
    let btn = document.querySelector(".EPMenuBar").querySelector(".draw");
    btn.style.backgroundColor = "var(--uiColor3)";

    _sketchView.create(`polyline`);
  }
  deleteAction() {
    let btn = document.querySelector(".EPMenuBar").querySelector(".draw");
    btn.style.backgroundColor = "#FFF";

    // disable download button
    let upload_btn = document
      .querySelector(".EPMenuBar")
      .querySelector(".download");
    upload_btn.style.backgroundColor = "lightgrey";
    upload_btn.style.pointerEvents = "none";

    _sketchView.cancel();
    _profile_layer.removeAll();
    _vertex_layer.removeAll();
    this.setPath();
    // clear Height
    let tmpGraphicsLayer = this.props.mapView.map.allLayers.find(
      (i) => i.title === "Elevation Profile Marker Layer"
    );
    tmpGraphicsLayer && tmpGraphicsLayer.graphics.removeAll();

    // console.log("hello",this.props);

    // echartRef = null;
  }

  downloadAction() {
    let btn = document.querySelector(".EPMenuBar").querySelector(".draw");
    btn.style.backgroundColor = "#FFF";
    // console.log("hello",echartRef);
    if (echartRef) {
      let echartInstance = echartRef.getEchartsInstance();
      let img = new Image();
      img.src = echartInstance.getDataURL();

      let sb = [];

      if (_profile_infos != null) {
        console.log(_profile_infos);
        sb = _profile_infos.reduce(
          (p, c, i) => ((i = Object.values(c.coords)), p.push(i.join(",")), p),
          []
        );
        console.log(sb);
        console.log("sbsb", echartInstance.getDataURL());
      }

      let header = "HK80_X,HK80_Y,Elevation,Distance\r\n";
      //download csv
      let csvContent = `data:text/csv;charset=utf-8, ${header +
        sb.join("\r\n")}`;
      let encodedUri = encodeURI(csvContent);
      // console.log("encodeURI",encodedUri);
      // window.open(encodedUri);

      this.props.showDialog({
        isOpen: true,
        title: "Export Elevation Profile Data",
        content: (
          <div>
            <p>
              <a
                href="javascript:void(0)"
                onClick={() =>
                  this.startDownload(
                    echartInstance.getDataURL(),
                    "Elevation_Profile.png",
                    "image/png",
                    true
                  )
                }
              >
                Elevation profile chart image (PNG)
              </a>
            </p>
            <p>
              <a
                href="javascript:void(0)"
                onClick={() =>
                  this.startDownload(
                    header + sb.join("\r\n"),
                    "Elevation_Profile.csv",
                    "data:text/csv;charset=utf-8",
                    false
                  )
                }
              >
                Elevation profile data (CSV)
              </a>
            </p>
          </div>
        ),
        cancelButtonText: "Close",
        onDialogCancel: () => {},
      });
    }
  }
  async setPath(path) {
    if (path) {
      // POLYGON TO POLYLINE //
      // if(path.type === "polygon") {
      //   path = this._polygonToPolyline(path);
      // }

      // enable download button when getting data
      let btn = document.querySelector(".EPMenuBar").querySelector(".download");
      btn.style.backgroundColor = "#fff";
      btn.style.pointerEvents = "initial";

      // DENSIFY POLYLINE//

      var polyline_length = 0; //geometryEngine.geodesicLength(path, "meters");
      var polyline = null; //geometryEngine.densify(path, (polyline_length / min_point_count), "meters");

      if (this.props.mapView.spatialReference.isWGS84) {
        polyline_length = geometryTools.geometryEngine.geodesicLength(
          path,
          "meters"
        );
        polyline = geometryTools.geometryEngine.densify(
          path,
          polyline_length / min_point_count,
          "meters"
        );
      } else {
        polyline_length = geometryTools.geometryEngine.planarLength(
          path,
          "meters"
        );
        polyline = geometryTools.geometryEngine.densify(
          path,
          polyline_length / min_point_count,
          "meters"
        );
      }

      let elevationSampler = await this.props.mapView.map.ground.layers.items[0].createElevationSampler(
        this.props.mapView.extent.clone().expand(2)
      );

      // ADD ELEVATIONS AS Z TO POLYLINE //
      const polyline_z = elevationSampler.queryElevation(polyline);

      let elevationPath = polyline_z.paths[0];
      let tmpGraphicsLayer = this.props.mapView.map.allLayers.find(
        (i) => i.title === "Sketch GraphicsLayer Vertex"
      );
      tmpGraphicsLayer.graphics.removeAll();
      elevationPath.forEach(
        (t, i) => {
          if (t[2] > 10000) {
            t[2] = 0;
            // return;
          }
          // if (i % 5 == 0) {
          let tmpSP = new geometryTools.SpatialReference({
            wkid: 102140,
          });
          let tmpPoint = new geometryTools.Point({
            x: t[0],
            y: t[1],
            z: t[2],
            spatialReference: tmpSP,
          });
          let tmpPointGraphic = new geometryTools.Graphic({
            geometry: tmpPoint,
            symbol:
              this.props.mapView.type === "2d"
                ? geometryTools.highlightSymbol.pointOfElevProfile
                : geometryTools.highlightSymbol.point3dOfElevProfile,
            spatialReference: tmpSP,
          });
          tmpGraphicsLayer.graphics.add(tmpPointGraphic);
        }
        // }
      );

      let scatterArr = [];
      for (let ptIdx = 0; ptIdx <= path.paths[0].length - 2; ptIdx++) {
        let ptA = path.paths[0][ptIdx];
        let ptB = path.paths[0][ptIdx + 1];
        let distance = this.distanceBetweenPoints(
          ptA[0],
          ptA[1],
          ptB[0],
          ptB[1]
        );
        let z =
          polyline_z.paths[0].find(
            (i) => i[0] == ptB[0] && i[1] == ptB[1]
          )?.[2] || 0;
        scatterArr.push([distance, z]);
      }
      scatterArr.forEach((i, j) => {
        if (j == 0) return;
        i[0] += scatterArr[j - 1][0];
      });
      chartOption.series[1].data = scatterArr;

      // ADD DISTANCES AS M TO POLYLINE //
      const polyline_zm = this._setMAsDistanceAlong(polyline_z);

      // GET PROFILE INFOS //
      const profile_infos = this._getProfileInfos(polyline_zm);
      // UPDATE ELEVATION PROFILE CHART //
      this._updateChart(profile_infos.chart_data);

      // PROFILE DETAILS //
      this._updateProfileDetails(profile_infos);
    } else {
      // CLEAR CHART //
      this._clearChart();
      // CLEAR DETAILS //
      this._updateProfileDetails();
    }
  }
  distanceBetweenPoints(x1, y1, x2, y2) {
    const deltaX = x2 - x1;
    const deltaY = y2 - y1;
    const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2);
    return distance;
  }
  _updateChart(infos) {
    _profile_infos = infos;
    console.log("updateChart", infos);
    chartOption.dataset.source = [].concat(
      infos
    ); /*.map((d) => {
      return { x: d.x, y: d.y, coords: d.coords, index: d.index };
    });*/
    this.setState({});
    // chart.setOption(chartOption);
  }
  _clearChart() {
    chartOption.dataset.source = [];
    chartOption.series[1].data = [];
    this.setState({});
    // chart.setOption(chartOption);
  }
  _getProfileInfos(polyline) {
    //console.info(polyline.paths.length, polyline.paths);

    const last_path = polyline.paths.length - 1;
    return polyline.paths.reduce(
      (infos, path, pathIdx) => {
        const last_coord = path.length - 1;
        return path.reduce((infos, coords, coordsIndex) => {
          if (pathIdx === 0 && coordsIndex === 0) {
            infos.first_z = coords[2];
          }
          if (pathIdx === last_path && coordsIndex === last_coord) {
            infos.last_z = coords[2];
          }

          infos.min_m = Math.min(infos.min_m, coords[3]);
          infos.max_m = Math.max(infos.max_m, coords[3]);
          infos.min_z = Math.min(infos.min_z, coords[2]);
          infos.max_z = Math.max(infos.max_z, coords[2]);

          infos.chart_data.push({
            y: coords[2] || 0.0, // Z //
            x: coords[3] || coordsIndex, // M //
            coords: coords,
            index: coordsIndex,
            symbol: "circle",
            itemStyle: {
              color: "black",
            },
          });

          return infos;
        }, infos);
      },
      {
        chart_data: [],
        first_z: -1,
        last_z: -1,
        min_m: Infinity,
        max_m: -Infinity,
        min_z: Infinity,
        max_z: -Infinity,
      }
    );
  }
  _updateProfileDetails(profile_infos) {
    // const num_format = num => number.format(num, { places: 1 });

    if (profile_infos) {
      const infos = [
        // `Distance:${num_format(profile_infos.max_m)}`,
        // `Elevation:`,
        `first: ${profile_infos.first_z.toFixed(1)}`,
        `last: ${profile_infos.last_z.toFixed(1)}`,
        `change: ${(profile_infos.last_z - profile_infos.first_z).toFixed(1)}`,
        `min: ${profile_infos.min_z.toFixed(1)}`,
        `max: ${profile_infos.max_z.toFixed(1)}`,
        `range: ${profile_infos.max_z - profile_infos.min_z}`,
      ];

      // this._detailsNode.innerHTML = infos.join("&nbsp;&nbsp;");
      // this._detailsNode.title = infos.join("  ");
    } else {
      // this._detailsNode.title = this._detailsNode.innerHTML = "";
    }
  }
  _setMAsDistanceAlong(polyline) {
    let distanceAlong = 0.0;
    return new geometryTools.Polyline({
      hasZ: true,
      hasM: true,
      spatialReference: polyline.spatialReference,
      paths: polyline.paths.map((part, partIdx) => {
        return part.map((coords, coordIdx) => {
          const location = polyline.getPoint(partIdx, coordIdx);
          const prevLocation = polyline.getPoint(
            partIdx,
            coordIdx > 0 ? coordIdx - 1 : 0
          );
          distanceAlong += geometryTools.geometryEngine.distance(
            prevLocation,
            location,
            "meters"
          );
          return [coords[0], coords[1], coords[2] || 0.0, distanceAlong];
        });
      }),
    });
  }
  startDownload(data, filename, type, isImage) {
    // http://stackoverflow.com/questions/13405129
    var a = document.createElement("a"),
      file = new Blob([data], { type: type });
    // https://msdn.microsoft.com/en-us/library/hh772332(v=vs.85).aspx
    if (window.navigator.msSaveOrOpenBlob)
      // IE10+
      window.navigator.msSaveOrOpenBlob(file, filename);
    else {
      // Others
      var url = isImage ? data : URL.createObjectURL(file);
      a.href = url;
      //"download" is a native HTML5 "A" attribute
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    }
  }
  showDialog(dialogSetup) {
    this.setState({ dialogSetup });
  }
  render() {
    return (
      <div className="ElevationProfileContainer EqualWidthChildren">
        <div className="EPMenuBar EqualWidthChildren column">
          <div onClick={() => this.props.mapUICallback("toggle3DElevation")}>
            <span className="icn_3d_Elevationprofile_close" />
          </div>
          <div className="draw" onClick={(e) => this.drawAction(e)}>
            <span className="icn_3d_Elevationprofile_draw" />
          </div>
          <div onClick={(e) => this.deleteAction(e)}>
            <span className="icn_3d_Elevationprofile_clearall" />
          </div>
          <div className="download" onClick={(e) => this.downloadAction(e)}>
            <span className="icn_3d_Elevationprofile_export" />
          </div>
        </div>
        <ReactECharts
          option={this.getOption()}
          style={{ height: "100%", backgroundColor: "#344C70" }}
          ref={(e) => {
            if (!echartRef) {
              echartRef = e;
            }
          }}
        />
        <div className="MenuButtonsMask" style={{ zoom: "0.8" }} />
      </div>
    );
  }
}
export default ElevationProfile;
